import backend from 'utils/backend'

export const FRONTEND_SETTINGS_SET = 'FRONTEND_SETTINGS_SET'

export const getFrontendSettings = async dispatch => {
  try {
    const { data } = await backend.get('api/frontend/settings/')
    if (data) {
      dispatch({ type: FRONTEND_SETTINGS_SET, payload: { data } })
    }
  } catch (ex) {
    console.log(ex)
  }
}
